import React from "react";

export default function Main() {
	const [img, setImg] = React.useState("");
	const [h, setH] = React.useState("");
	const [recipeInfo, setRecipeInfo] = React.useState("");
	const [message, setMessage] = React.useState("");

	const handleChange = (event) => {
		setMessage(event.target.value);
		console.log("value is:", event.target.value);
	};
	function getMealList() {
		const options = {
			// method: "GET",
			// headers: {
			// 	"Accept: application/json":
			// 		"https://api.edamam.com/api/recipes/v2?type=public&q=chicken&app_id=51f4787c&app_key=eda47d6044288c9ea1525aea94241199&diet=high-protein",
			// },
		};

		fetch(
			`https://api.edamam.com/api/recipes/v2?type=public&q=${message}&app_id=51f4787c&app_key=eda47d6044288c9ea1525aea94241199&diet=high-protein`
		)
			.then((response) => response.json())
			.then((response) => {
				let randomRecipe = Math.round(Math.random() * 20);
				console.log(randomRecipe);
				console.log(response);
				console.log(response.hits[randomRecipe].recipe.images.REGULAR.url);
				setImg(response.hits[randomRecipe].recipe.images.REGULAR.url);
				setH(<h2>{response.hits[randomRecipe].recipe.label}</h2>);
				setRecipeInfo(
					<p className="info-container">
						<p>
							<span className="ingredient-font">Calories:</span>
							<br></br>
							{Math.round(response.hits[randomRecipe].recipe.calories)}
						</p>
						<p className="hashtag">
							#{response.hits[randomRecipe].recipe.cuisineType}#
							{response.hits[randomRecipe].recipe.dishType}
						</p>
						{console.log(response.hits[randomRecipe].recipe.digest[0])}
						<span className="ingredient-font">Macros</span>
						<div className="ingredients-container">
							{response.hits[randomRecipe].recipe.digest.slice(0, 3).map((item) => {
								return (
									<div>
										<p>
											{item.label} : {Math.round(item.total)} g
										</p>
									</div>
								);
							})}
							<p className="hashtag">
								#Number of servings : {response.hits[randomRecipe].recipe.yield}
							</p>
						</div>
						<span className="ingredient-font">Ingredients:</span>
						<div className="ingredients-container">
							<ul>
								{response.hits[randomRecipe].recipe.ingredients.map(({ text }) => (
									<li>{text}</li>
								))}
								{console.log(response.hits[2].recipe.ingredients[0])}
							</ul>
						</div>
					</p>
				);
			})
			.catch((err) => console.error(err));
	}
	return (
		<div className="main-container">
			<h2>Made with React.js</h2>
			<br></br>
			<input
				type={"text"}
				placeholder={"insert keywords here"}
				className="keywords-input"
				onChange={handleChange}
			/>
			<br></br>
			<button onClick={getMealList} className="generate-button">
				Generate Meal
			</button>
			<br></br>
			<div className="recipe-container">
				<img src={img} alt="#" />
				<div className="heading-wrapper">{h}</div>
				{recipeInfo}
			</div>
		</div>
	);
}
